<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-left">
      <h4 class="modal-title">{{ title }}</h4>
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="modal-body-inner mb-3">
      <div class="form-custom-div">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="lookup-fields-root">
              <div
                class="lookup-fields-row"
                *ngFor="let lookupField of form.controls; let i = index"
                [formGroup]="getFormGroup(lookupField)"
              >
                <div
                  class="form-group select2-form-group action-add-remove-group"
                >
                  <div class="row-select-group d-flex">
                    <app-checkbox
                      *ngIf="booleanField"
                      class="d-flex align-items-center"
                      title="Include in Form List"
                      [form]="getFormGroup(lookupField)"
                      [controlName]="booleanField"
                    >
                    </app-checkbox>
                    <app-select
                      class="w-100"
                      title="Name"
                      [form]="getFormGroup(lookupField)"
                      [options]="fields"
                      [controlName]="fieldName"
                      (selected)="fieldSelected()"
                    ></app-select>
                    <div class="button-group-action d-flex">
                      <button
                        type="button"
                        *ngIf="i === form.controls.length - 1"
                        (click)="addField()"
                        class="btn btn-primary btn-add"
                      >
                        <i class="icon-add"></i>
                      </button>
                      <button
                        type="button"
                        *ngIf="i !== 0 || form.controls.length > 1"
                        (click)="removeField(i)"
                        class="btn btn-danger btn-remove"
                      >
                        <i class="icon-delete delete-icon"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bottom">
      <div class="modal-footer-bottom-row">
        <button
          type="button"
          class="btn btn-cancel text-uppercase mr-10"
          (click)="close()"
        >
          Cancel
        </button>
        <button
          [disabled]="form.invalid"
          type="button"
          class="btn btn-common-primary text-uppercase"
          (click)="onSave()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
